<form
  [formGroup]="postForm"
  (ngSubmit)="onSubmit()"
  class="w-11/12 mx-auto my-0 z-0"
>
		<!-- #region step 1 -->
	<div class="flex justify-end -mt-10">
		<button
			type="submit"
			[class.opacity-1]
			(click)="saveDraft($event)"
			[class.cursor-not-allowed]="!IsDraftValid()"
			[disabled]="!IsDraftValid()"
			class="flex-grow-0 px-4 py-1 font-normal rounded-full focus:outline-none border-2 border-[#8693A6] text-base sm:text-sm md:text-lg lg:text-xl transition-colors"
			[ngClass]="{
				'bg-white text-[#544E61] hover:bg-[#8693A6] hover:text-white': IsDraftValid() && !(draftSaved || draftIsSaving),
				'bg-gray-300 text-gray-400': !IsDraftValid(),
				'cursor-not-allowed bg-[#8693A6] text-white': draftSaved || draftIsSaving
			}"
			[style.width.px]="screenWidth * 16.8/100?screenWidth * 16.8/100>225:225"
		>
			<div class="flex justify-center items-center gap-2" >
				<!-- Regular icon -->
				<svg 
					[ngClass]="{
						'hidden': draftSaved || draftIsSaving
					}" 
					width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
				>
					<path fill="currentColor" d="M21.21 16.71L18.79 14.29C18.697 14.1963 18.5864 14.1219 18.4646 14.0711C18.3427 14.0203 18.212 13.9942 18.08 13.9942C17.948 13.9942 17.8173 14.0203 17.6954 14.0711C17.5736 14.1219 17.463 14.1963 17.37 14.29L13.79 17.87C13.6973 17.9634 13.624 18.0743 13.5742 18.1961C13.5245 18.3179 13.4992 18.4484 13.5 18.58V21C13.5 21.2652 13.6054 21.5196 13.7929 21.7071C13.9804 21.8946 14.2348 22 14.5 22H16.92C17.0516 22.0008 17.1821 21.9755 17.3039 21.9258C17.4257 21.876 17.5366 21.8027 17.63 21.71L21.21 18.13C21.3037 18.037 21.3781 17.9264 21.4289 17.8046C21.4797 17.6827 21.5058 17.552 21.5058 17.42C21.5058 17.288 21.4797 17.1573 21.4289 17.0354C21.3781 16.9136 21.3037 16.803 21.21 16.71ZM16.5 20H15.5V19L18.08 16.42L19.08 17.42L16.5 20ZM10.5 20H6.5C6.23478 20 5.98043 19.8946 5.79289 19.7071C5.60536 19.5196 5.5 19.2652 5.5 19V5C5.5 4.73478 5.60536 4.48043 5.79289 4.29289C5.98043 4.10536 6.23478 4 6.5 4H11.5V7C11.5 7.79565 11.8161 8.55871 12.3787 9.12132C12.9413 9.68393 13.7044 10 14.5 10H17.5V11C17.5 11.2652 17.6054 11.5196 17.7929 11.7071C17.9804 11.8946 18.2348 12 18.5 12C18.7652 12 19.0196 11.8946 19.2071 11.7071C19.3946 11.5196 19.5 11.2652 19.5 11V9C19.5 9 19.5 9 19.5 8.94C19.4896 8.84813 19.4695 8.75763 19.44 8.67V8.58C19.3919 8.47718 19.3278 8.38267 19.25 8.3L13.25 2.3C13.1673 2.22222 13.0728 2.15808 12.97 2.11C12.9402 2.10576 12.9099 2.10576 12.88 2.11L12.56 2H6.5C5.70435 2 4.94129 2.31607 4.37868 2.87868C3.81607 3.44129 3.5 4.20435 3.5 5V19C3.5 19.7956 3.81607 20.5587 4.37868 21.1213C4.94129 21.6839 5.70435 22 6.5 22H10.5C10.7652 22 11.0196 21.8946 11.2071 21.7071C11.3946 21.5196 11.5 21.2652 11.5 21C11.5 20.7348 11.3946 20.4804 11.2071 20.2929C11.0196 20.1054 10.7652 20 10.5 20ZM13.5 5.41L16.09 8H14.5C14.2348 8 13.9804 7.89464 13.7929 7.70711C13.6054 7.51957 13.5 7.26522 13.5 7V5.41ZM8.5 14H14.5C14.7652 14 15.0196 13.8946 15.2071 13.7071C15.3946 13.5196 15.5 13.2652 15.5 13C15.5 12.7348 15.3946 12.4804 15.2071 12.2929C15.0196 12.1054 14.7652 12 14.5 12H8.5C8.23478 12 7.98043 12.1054 7.79289 12.2929C7.60536 12.4804 7.5 12.7348 7.5 13C7.5 13.2652 7.60536 13.5196 7.79289 13.7071C7.98043 13.8946 8.23478 14 8.5 14ZM8.5 10H9.5C9.76522 10 10.0196 9.89464 10.2071 9.70711C10.3946 9.51957 10.5 9.26522 10.5 9C10.5 8.73478 10.3946 8.48043 10.2071 8.29289C10.0196 8.10536 9.76522 8 9.5 8H8.5C8.23478 8 7.98043 8.10536 7.79289 8.29289C7.60536 8.48043 7.5 8.73478 7.5 9C7.5 9.26522 7.60536 9.51957 7.79289 9.70711C7.98043 9.89464 8.23478 10 8.5 10ZM10.5 16H8.5C8.23478 16 7.98043 16.1054 7.79289 16.2929C7.60536 16.4804 7.5 16.7348 7.5 17C7.5 17.2652 7.60536 17.5196 7.79289 17.7071C7.98043 17.8946 8.23478 18 8.5 18H10.5C10.7652 18 11.0196 17.8946 11.2071 17.7071C11.3946 17.5196 11.5 17.2652 11.5 17C11.5 16.7348 11.3946 16.4804 11.2071 16.2929C11.0196 16.1054 10.7652 16 10.5 16Z"/>
				</svg>

				<!-- Loader Icon -->
				<svg
					[ngClass]="{
						'hidden': !draftIsSaving
					}" 
					class="spinner"
					width="25"
					height="25"
					viewBox="0 0 50 50"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<!-- Circular path with a gap -->
					<path
						d="M25 5
							A 20 20 0 0 1 45 25
							A 20 20 0 0 1 20 45"
						stroke="currentColor"
						stroke-width="4"
						stroke-linecap="round"
					/>
				</svg>
								
				<!-- Checkmark icon -->
				<svg 
					[ngClass]="{
						'hidden': !draftSaved
					}" 
					width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M16.7319 5.2958C16.639 5.20207 16.5284 5.12768 16.4065 5.07691C16.2846 5.02614 16.1539 5 16.0219 5C15.8899 5 15.7592 5.02614 15.6373 5.07691C15.5155 5.12768 15.4049 5.20207 15.3119 5.2958L7.86192 12.7558L4.73192 9.6158C4.6354 9.52256 4.52146 9.44925 4.3966 9.40004C4.27175 9.35084 4.13843 9.32671 4.00424 9.32903C3.87006 9.33135 3.73765 9.36008 3.61458 9.41357C3.4915 9.46706 3.38016 9.54428 3.28692 9.6408C3.19368 9.73732 3.12037 9.85126 3.07117 9.97612C3.02196 10.101 2.99783 10.2343 3.00015 10.3685C3.00247 10.5027 3.0312 10.6351 3.0847 10.7581C3.13819 10.8812 3.2154 10.9926 3.31192 11.0858L7.15192 14.9258C7.24489 15.0195 7.35549 15.0939 7.47735 15.1447C7.59921 15.1955 7.72991 15.2216 7.86192 15.2216C7.99393 15.2216 8.12464 15.1955 8.2465 15.1447C8.36836 15.0939 8.47896 15.0195 8.57192 14.9258L16.7319 6.7658C16.8334 6.67216 16.9144 6.5585 16.9698 6.432C17.0252 6.30551 17.0539 6.1689 17.0539 6.0308C17.0539 5.8927 17.0252 5.75609 16.9698 5.62959C16.9144 5.50309 16.8334 5.38944 16.7319 5.2958Z" fill="white"/>
				</svg>
					
				<!-- <span [ngStyle]="{'font-size': screenHeight/45 + 'px'}"> -->
				<span class="text-sm">
					{{ draftSaved ? ("posts.draftSaved" | translate) : ("posts.saveDraft" | translate) }}
				</span>
			</div>
		</button>
	</div>
	 
	<fieldset
		class="relative border-dark_blue border-4 rounded-3xl pb-6 w-full min-h-[5vh] flex flex-col justify-between h-[80vh]"
		style="border-radius: 3rem"
		[ngStyle]="{'min-height': screenHeight *70.15/100 + 'px;'}"
		[style.width.px]="screenWidth * 75.2/100"
	>
		<legend
			class="text-2xl font-semibold ml-8 mb-1 bg-dark_blue text-white px-4 py-1 rounded-full"
			style="padding-right: 44px"
		>
			{{ (postAction != "update" ? "posts.createPost" : "posts.editing") | translate }}
		</legend>


		<div class="step1 overflow-auto relative" *ngIf="creationStep == 0">
			<!-- LOAD OVERLAY -->
			<div
				[@fadeAnimation]="loadPost"
				class="absolute rounded-3xl top-0 bottom-0 left-0 right-0 bg-indigo-100 z-30 flex items-center justify-center"
				(@fadeAnimation.done)="onAnimationDone($event)"
			>
				<!-- Bouncing dots -->
				<div class="flex justify-center items-center space-x-1">
					<div class="w-2 h-2 rounded-full bg-gray-400 animate-dot1"></div>
					<div class="w-2 h-2 rounded-full bg-gray-400 animate-dot2"></div>
					<div class="w-2 h-2 rounded-full bg-gray-400 animate-dot3"></div>
				</div>
			</div>

			<div class="flex w-full">
				<div class="w-2/3 relative">
					<!-- post title -->
					<div class="m-5">
						<fieldset class="border border-cliking_red border-1 rounded-full relative flex items-center justify-center" [ngClass]="{'border-cliking_red ':fieldsetColorTitle ,'border-black':!fieldsetColorTitle}"
						[ngStyle]="{'height': screenHeight *0.93/10 + 'px'}"
						[style.width.px]="screenWidth * 46.76/100"
						>            
							<legend [ngStyle]="{'font-size': screenHeight/60 + 'px'}" class="px-1 ml-10">
								{{ "posts.enterPostTitle" | translate }}
							</legend>
							<input
								type="text"
								name="title"
								id="title"
								formControlName="title"
								required
								class="px-5 py-[3px] mt-3 mb-5 mx-auto my-auto block w-11/12 text-base border border-1 border-black rounded-3xl"
								placeholder=""
								(blur)="titleValidation()"
								[ngStyle]="{'height': screenHeight - screenHeight*9.65/10 + 'px'}"
								(keydown.enter)="$event.preventDefault();"
							/>
						</fieldset>
						<app-tooltip-left (onToolTipHeightCalculated)="updateHeight($event, 0)" [visibilityFlag]="toolTipMsgTitle" [msg]="'posts.step1Validation.postTitle'" class="flex  absolute " [ngClass]="{'-right-[37%]': screenWidth>1650, '-right-[38%]': 1400<screenWidth && screenWidth<1650, '-right-[39%]': 1200<screenWidth && screenWidth<1400,  '-right-[40%]': screenWidth<1200}" [ngStyle]="{'margin-top': - screenHeight*3.5/100 - toolTiHeights[0]/2 - 3+ 'px'}"/>
					</div>
					
					<!-- *ngIf="postAction == 'update'" -->

					<!-- social media platforms -->
					<div class="m-5">
						<fieldset class="border border-1 rounded-full relative flex items-center justify-center" 
							[ngStyle]="{'height': screenHeight *0.93/10 + 'px'}"
							[style.width.px]="screenWidth * 46.76/100"
							[ngClass]="{
								'border-cliking_red ': fieldsetColorPlateforms,
								'border-black': !fieldsetColorPlateforms,
								'border-opacity-50 cursor-not-allowed': isUpdate(),
							}"
						>
							<legend [ngStyle]="{'font-size': screenHeight/60 + 'px'}" class="ml-10 px-1" [ngClass]="{'opacity-50': isUpdate(),}">
								{{ "posts.chooseSocialMediaPlatform" | translate }}
							</legend>

							<!-- if update: message can't edit -->
							<div *ngIf="isUpdate()" class="text-xs absolute -top-[4px] right-3 transform -translate-y-full bg-indigo-100 px-2">
								<div class="opacity-50">{{ "pages.fieldNotEditable" | translate}}</div>
							</div>
							
							<div class="grid grid-rows-1 grid-cols-4 gap-8 w-11/12 mx-auto">

								<!-- btn LINKEDIN -->
								<button
									type="button"
									class="  "
									button
									(click)="isUpdate() || !linkedinExists ? null : selectPlatform('linkedin', true)"
									(mouseover)="isUpdate() || !linkedinExists ? null : hoveredPlatforms.add('linkedin')"
									(mouseleave)="isUpdate() || !linkedinExists ? null : hoveredPlatforms.delete('linkedin')"
									[ngClass]="{
										'bg-white text-gray-500': linkedinExists && !selectedPlatform.includes(SocialMediaPlatform.LINKEDIN),
										'bg-sky-600 text-white ': linkedinExists && selectedPlatform.includes(SocialMediaPlatform.LINKEDIN),
										'hover:bg-sky-700 hover:text-white': linkedinExists && !isUpdate(),
										'text-gray-400  border-gray-300 bg-gray-300': !linkedinExists,
										'opacity-50': isUpdate(),
									}"
									[ngStyle]="{'height': screenHeight - screenHeight*9.65/10 + 'px'}"
									[disabled]="!linkedinExists"
									type="button"
									[class.cursor-not-allowed]="!linkedinExists || isUpdate()"
									class="flex items-center my-auto mt-3 mb-6 ml-2 px-2 py-0 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none"
								>
									<img
										class="m-auto py-1"
										[src]="hoveredPlatforms.has('linkedin')
											? 'assets/img/linkedin-logo.png'
											: selectedPlatform.includes(SocialMediaPlatform.LINKEDIN)
												? 'assets/img/linkedin-logo.png'
												: 'assets/img/linkedin-logo-disabled.png'
										"
										alt="linkedin"
										[ngStyle]="{'width': screenHeight - screenHeight*9.3/10 + 'px'}"
									/>
								</button>

								<!-- btn GOOGLE -->
								<button
									type="button"
									button
									(click)="isUpdate() || !googleExists ? null : selectPlatform('google', true)"
									(mouseover)="isUpdate() || !googleExists ? null : hoveredPlatforms.add('google')"
									(mouseleave)="isUpdate() || !googleExists ? null : hoveredPlatforms.delete('google')"
									[ngClass]="{
										'bg-orange-600 text-white': googleExists && selectedPlatform.includes(SocialMediaPlatform.GOOGLE),
										'hover:bg-orange-700 hover:text-white': googleExists && !isUpdate(),
										'bg-white text-gray-500': googleExists && !selectedPlatform.includes(SocialMediaPlatform.GOOGLE),
										'bg-gray-300 text-gray-400': !googleExists,
										'opacity-50': isUpdate(),
									}"
									[disabled]="!googleExists"
									type="button"
									[class.cursor-not-allowed]="!googleExists || isUpdate()"
									class="flex items-center mt-3 mb-6 px-4 py-0 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none"
								>
									<img
										class="m-auto"
										[src]="hoveredPlatforms.has('google')
											? 'assets/img/google-logo.png'
											: selectedPlatform.includes(SocialMediaPlatform.GOOGLE)
												? 'assets/img/google-logo.png'
												: 'assets/img/google-logo-disabled.png'
										"
										alt="google"
										[ngStyle]="{'width': screenHeight - screenHeight*9.4/10 + 'px'}"
									/>
								</button>

								<!-- btn FACEBOOK -->
								<button
									type="button"
									button
									(click)="isUpdate() || !facebookExists ? null : selectPlatform('facebook', true)"
									(mouseover)="isUpdate() || !facebookExists ? null : hoveredPlatforms.add('facebook')"
									(mouseleave)="isUpdate() || !facebookExists ? null : hoveredPlatforms.delete('facebook')"
									[ngClass]="{
										'bg-blue-600 text-white ': facebookExists && selectedPlatform.includes(SocialMediaPlatform.FACEBOOK),
										'hover:bg-blue-700 hover:text-white': facebookExists && !isUpdate(),
										'bg-white text-gray-500': facebookExists && !selectedPlatform.includes(SocialMediaPlatform.FACEBOOK),
										'bg-gray-300 text-gray-400': !facebookExists,
										'opacity-50': isUpdate(),
									}"
									[disabled]="!facebookExists"
									type="button"
									[class.cursor-not-allowed]="!facebookExists || isUpdate()"
									class="flex items-center mt-3 mb-6 px-4 py-0 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none"
								>
									<img
										class="m-auto"
										[src]="hoveredPlatforms.has('facebook')
											? 'assets/img/facebook-logo.png'
											: selectedPlatform.includes(SocialMediaPlatform.FACEBOOK)
												? 'assets/img/facebook-logo.png'
												: 'assets/img/facebook-logo-disabled.png'
										"
										alt="facebook"
										[ngStyle]="{'width': screenHeight - screenHeight*9.3/10 + 'px'}"
									/>
								</button>

								<!-- btn INSTAGRAM -->
								<button
									button
									(click)="isUpdate() || !instagramExists ? null : selectPlatform('instagram', true)"
									(mouseover)="isUpdate() || !instagramExists ? null : hoveredPlatforms.add('instagram')"
									(mouseleave)="isUpdate() || !instagramExists ? null : hoveredPlatforms.delete('instagram')"
									[ngClass]="{
										'bg-pink-600 text-white': instagramExists && selectedPlatform.includes(SocialMediaPlatform.INSTAGRAM) && !isUpdate(),
										'bg-pink-600/50': instagramExists && selectedPlatform.includes(SocialMediaPlatform.INSTAGRAM) && isUpdate(),
										'hover:bg-pink-700 hover:text-white': instagramExists && !isUpdate(),
										'bg-white text-gray-500': instagramExists && !selectedPlatform.includes(SocialMediaPlatform.INSTAGRAM),
										'bg-gray-300 text-gray-400': !instagramExists,
									}"
									[disabled]="!instagramExists"
									type="button"
									[class.cursor-not-allowed]="!instagramExists || isUpdate()"
									class="flex items-center mt-3 mb-6 px-4 py-0 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none relative"
								>
								<img
									class="m-auto"
									[src]="hoveredPlatforms.has('instagram')
										? 'assets/img/instagram-logo.png'
										: selectedPlatform.includes(SocialMediaPlatform.INSTAGRAM)
											? 'assets/img/instagram-logo.png'
											: 'assets/img/instagram-logo-disabled.png'
									"
									alt="instagram"
									[ngStyle]="{'width': screenHeight - screenHeight*9.3/10 + 'px'}"
									/>
								<div 
									*ngIf="isUpdate() && hasInstagram()" 
									(click)="updateModaleOpen = true" 
									class="absolute -top-1 -right-1 cursor-pointer bg-white border border-1 border-cliking_red rounded-full z-20 p-1 !opacity-100"
								>
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M8 10.6667C7.86815 10.6667 7.73925 10.7058 7.62962 10.779C7.51999 10.8523 7.43454 10.9564 7.38408 11.0782C7.33362 11.2 7.32042 11.3341 7.34614 11.4634C7.37187 11.5927 7.43536 11.7115 7.5286 11.8048C7.62183 11.898 7.74062 11.9615 7.86994 11.9872C7.99926 12.0129 8.13331 11.9997 8.25512 11.9493C8.37694 11.8988 8.48106 11.8134 8.55431 11.7037C8.62757 11.5941 8.66667 11.4652 8.66667 11.3334C8.66667 11.1565 8.59643 10.987 8.4714 10.8619C8.34638 10.7369 8.17681 10.6667 8 10.6667ZM15.1133 11.6467L9.74667 2.31335C9.5732 2.00236 9.31986 1.74332 9.0128 1.563C8.70573 1.38267 8.3561 1.2876 8 1.2876C7.6439 1.2876 7.29427 1.38267 6.98721 1.563C6.68014 1.74332 6.4268 2.00236 6.25333 2.31335L0.920001 11.6467C0.740531 11.9494 0.644096 12.294 0.64043 12.6459C0.636765 12.9978 0.725999 13.3444 0.899125 13.6507C1.07225 13.9571 1.32314 14.2123 1.62646 14.3907C1.92978 14.5691 2.27479 14.6643 2.62667 14.6667H13.3733C13.728 14.6702 14.0773 14.5793 14.3853 14.4033C14.6933 14.2273 14.9489 13.9726 15.126 13.6652C15.3031 13.3579 15.3952 13.009 15.393 12.6542C15.3908 12.2995 15.2943 11.9518 15.1133 11.6467ZM13.96 12.98C13.9016 13.084 13.8163 13.1704 13.7131 13.2302C13.6099 13.29 13.4926 13.321 13.3733 13.32H2.62667C2.50741 13.321 2.39007 13.29 2.28688 13.2302C2.18369 13.1704 2.09844 13.084 2.04 12.98C1.98149 12.8787 1.95068 12.7637 1.95068 12.6467C1.95068 12.5297 1.98149 12.4147 2.04 12.3134L7.37333 2.98002C7.42928 2.87082 7.51428 2.77917 7.61896 2.71518C7.72365 2.65119 7.84397 2.61733 7.96667 2.61733C8.08936 2.61733 8.20968 2.65119 8.31437 2.71518C8.41906 2.77917 8.50406 2.87082 8.56 2.98002L13.9267 12.3134C13.9928 12.4132 14.0308 12.5291 14.0367 12.6488C14.0425 12.7684 14.0161 12.8875 13.96 12.9934V12.98ZM8 5.33335C7.82319 5.33335 7.65362 5.40359 7.5286 5.52861C7.40357 5.65364 7.33333 5.82321 7.33333 6.00002V8.66669C7.33333 8.8435 7.40357 9.01307 7.5286 9.13809C7.65362 9.26311 7.82319 9.33335 8 9.33335C8.17681 9.33335 8.34638 9.26311 8.4714 9.13809C8.59643 9.01307 8.66667 8.8435 8.66667 8.66669V6.00002C8.66667 5.82321 8.59643 5.65364 8.4714 5.52861C8.34638 5.40359 8.17681 5.33335 8 5.33335Z" fill="#FD397A"/>
									</svg>
								</div>
								</button>
							</div>
							<!-- Backdrop for opacity -->
							<!-- <div *ngIf="isUpdate()" class="absolute top-0 right-0 left-0 bottom-0 bg-indigo-100 opacity-50 z-10 cursor-not-allowed"></div>  -->
						</fieldset>
						<app-tooltip-left (onToolTipHeightCalculated)="updateHeight($event, 1)" [visibilityFlag]="toolTipMsgPlateforms" [msg]="'posts.step1Validation.choosePlateformSource'"  class="flex absolute" [ngClass]="{'-right-[37%]': screenWidth>1650, '-right-[38%]': 1400<screenWidth && screenWidth<1650, '-right-[39%]': 1200<screenWidth && screenWidth<1400,  '-right-[40%]': screenWidth<1200}" [ngStyle]="{'margin-top': - screenHeight*3.5/100 - toolTiHeights[1]/2 - 3+ 'px'}"/>
						
					</div>

					<!-- socialmedia page drop down -->
							
					<div class="mt-5 mr-5">
						<fieldset
							class="ml-5 px-1 text-sm border border-1 rounded-full relative"
							[ngStyle]="{'height': screenHeight *0.93/10 + 'px'}"
							[style.width.px]="screenWidth * 46.76/100"
						
							[ngClass]="{
								'border-cliking_red': fieldsetColorPages,
								'border-black': !fieldsetColorPages,
								'opacity-50 cursor-not-allowed': isUpdate(),
							}"
						>
							<legend [ngStyle]="{'font-size': screenHeight/60 + 'px'}" class="ml-10 px-1">
								{{ "posts.choosePlatformPage" | translate }}
							</legend>

							<!-- if update: message can't edit -->
							<div *ngIf="isUpdate()" class="text-xs absolute -top-[1px] right-3 transform -translate-y-full bg-indigo-100 px-2">
								{{ "pages.fieldNotEditable" | translate}}
							</div>

							<!-- if no page -->
							<span 
								*ngIf="socialMediaPagesList.length == 0"
								class="flex items-center w-11/12 mx-auto mt-[1.75%] pl-8 border c-border-blue rounded-full focus:outline-none focus:ring-cliking_blue focus:c-border-blue c-text-blue bg-gray-300"
								[style]="'height:'+ (screenHeight - screenHeight*9.65/10) + 'px; font-size:' +screenHeight/60 + 'px'"
							>
							</span>

							<!-- if only one page -->
							<span 
								*ngIf="socialMediaPagesList.length == 1"
								class="flex items-center w-11/12 mx-auto mt-[1.75%] pl-8 border c-border-blue rounded-full focus:outline-none focus:ring-cliking_blue focus:c-border-blue c-text-blue bg-white"
								[style]="'height:'+ (screenHeight - screenHeight*9.65/10) + 'px; font-size:' +screenHeight/60 + 'px'"
							>
								<div class="flex items-center">
									<span class="ml-2">
										<svg
											[style.width.px]="(screenHeight / 55)"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
											<g
												id="SVGRepo_tracerCarrier"
												stroke-linecap="round"
												stroke-linejoin="round"
											></g>
											<g id="SVGRepo_iconCarrier">
												<path
													d="M4 10.1433C4 5.64588 7.58172 2 12 2C16.4183 2 20 5.64588 20 10.1433C20 14.6055 17.4467 19.8124 13.4629 21.6744C12.5343 22.1085 11.4657 22.1085 10.5371 21.6744C6.55332 19.8124 4 14.6055 4 10.1433Z"
													stroke="#5C78FF"
													stroke-width="1.5"
												></path>
												<circle
													cx="12"
													cy="10"
													r="3"
													stroke="#5C78FF"
													stroke-width="1.5"
												></circle>
											</g>
										</svg>
									</span>
									<div
										[ngClass]="getPlatformProperty(socialMediaPagesList[0].source, 'bg_class')"
										class="inline-block rounded-md ml-2 text-white"
									>
										<img
											[style.width.px]="(screenWidth / 25)"
											[style.height.px]="(screenHeight / 55)"
											[src]="getPlatformProperty(socialMediaPagesList[0].source, 'logoPath')"
											alt="{{ getPlatformProperty(socialMediaPagesList[0].source, 'name') }} Logo"
											class="object-contain h-4 w-16 flex justify-content-between"
										/>
									</div>
									<span
										class="ml-2 mr-3 text-gray-700 font-sans block truncate rounded-sm"
										[ngStyle]="{'font-size': (screenHeight / 60) + 'px'}"
									>
										{{ socialMediaPagesList[0].name }}
									</span>
								</div>

							</span>

							<!-- If 2+ pages -->
							<app-dropdown
								[isMultiSelect]="true"
								[enableFuzzySearch]="false"
								[caption]="'socialMedia.choosePage' | translate"
								[data]="uniquePageList( socialMediaPagesList)"
								(booleanEmitter)="handleBoolean($event)"
								(selectedPagesSourcesChange)="selectedPagesSourcesChange($event)"
								[precheckedPages]="postUrl ? urlPostToggledItems : null"
								[tailwindCss]="
									'flex justify-content-between items-center justify-center w-11/12 mx-auto mt-[1.75%] pl-8 border c-border-blue rounded-full focus:outline-none focus:ring-cliking_blue focus:c-border-blue c-text-blue bg-white'
								"
								[ngClass]="{'hidden': uniquePageList( socialMediaPagesList).length < 2}"
								[customCss]="'height:'+ (screenHeight - screenHeight*9.65/10) + 'px;'"
								[sizeCss]="'font-size:' +screenHeight/60 + 'px'"
								[isUpdate]="isUpdate()"
							></app-dropdown>
						</fieldset>
						<app-tooltip-left (onToolTipHeightCalculated)="updateHeight($event, 2)" [visibilityFlag]="toolTipMsgPages" [msg]="'posts.step1Validation.selectminimumOnePage'" class="flex absolute" [ngClass]="{'-right-[37%]': screenWidth>1650, '-right-[38%]': 1400<screenWidth && screenWidth<1650, '-right-[39%]': 1200<screenWidth && screenWidth<1400,  '-right-[40%]': screenWidth<1200}" [ngStyle]="{'margin-top': - screenHeight*3.5/100 - toolTiHeights[2]/2 - 3+ 'px'}"/>
					</div>
					
					<!-- publication type -->
					<!-- empty div with same size if no google page selected -->
					<div class="mr-5 mt-3" *ngIf="!isGooglePageSelected()"
						[ngStyle]="{'height': screenHeight *0.93/10 + 'px'}"
					></div> 

					<div class="mr-5 mt-3" *ngIf="isGooglePageSelected()">
						<fieldset
							class="ml-5 px-1 text-sm border border-1 rounded-full flex items-center relative"
							[ngStyle]="{'height': screenHeight *0.93/10 + 'px'}"
							[style.width.px]="screenWidth * 46.76/100"
							[ngClass]="{
								'border-cliking_red': fieldsetColorGoogle, 
								'border-black': !fieldsetColorGoogle,
								'opacity-50 cursor-not-allowed': isUpdate(),
							}"
						>
							<legend [ngStyle]="{'font-size': screenHeight/60 + 'px'}" class="ml-10 px-1">
								{{ "posts.choosePostType" | translate }}
							</legend>

							<!-- if update: message can't edit -->
							<div *ngIf="isUpdate()" class=" text-xs absolute -top-[1px] right-3 transform -translate-y-full bg-indigo-100 px-2">
								{{ "pages.fieldNotEditable" | translate}}
							</div>

							<div class="grid grid-rows-1 grid-cols-3 gap-8 w-11/12 m-auto">
								<!-- update -->
								<button
									type="button"
									(click)="isUpdate() ? null : switchPostType('update')"
									[ngClass]="{
										'c-bg-blue text-white': isUpdateSelected,
										'hover:bg-cliking_blue hover:text-white': !isUpdate(),
										'bg-white text-gray-400': !isUpdateSelected,
										'cursor-not-allowed': isUpdate(),
									}"
									[ngStyle]="{'height': screenHeight - screenHeight*9.65/10 + 'px'}"
									class="flex items-center mt-3 mb-6 ml-2 px-2 py-1 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none"
								>
									<svg
										class="ml-1 mr-2 flex-shrink-0 h-5 w-5 text-inherit bg-inherit"
										fill="currentColor"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 576 512"
										[ngStyle]="{'width': screenHeight/60 + 'px'}"
									>
										<path
											d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
										/>
									</svg>
									<span [ngStyle]="{'font-size': screenHeight/60 + 'px'}">
										{{ "posts.typeUpdate" | translate }}
									</span>
								</button>

								<!-- event -->
								<button type="button"
									(click)="isUpdate() ? null : switchPostType('event')"
									[ngClass]="{
										'c-bg-blue text-white': isEventSelected,
										'hover:bg-cliking_blue hover:text-white': !isUpdate(),
										'bg-white text-gray-400': !isEventSelected,
										'cursor-not-allowed': isUpdate(),
									}"
									class="flex items-center mt-3 mb-6 px-4 py-1 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none"
								>
									<svg class="ml-1 mr-2 flex-shrink-0 h-5 w-5 text-inherit bg-inherit"
										fill="currentColor"
										xmlns="http://www.w3.org/2000/svg"
										[ngStyle]="{'width': screenHeight/60 + 'px'}"
										viewBox="0 0 576 512"
									>
										<path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
									</svg>
									<span [ngStyle]="{'font-size': screenHeight/60 + 'px'}">
										{{ "posts.typeEvent" | translate }}
									</span>
								</button>
											
								<!-- offer -->
								<button type="button"
									(click)="isUpdate() ? null : switchPostType('offer')"
									[ngClass]="{
										'c-bg-blue text-white': isOfferSelected,
										'hover:bg-cliking_blue hover:text-white': !isUpdate(),
										'bg-white text-gray-400': !isOfferSelected,
										'cursor-not-allowed': isUpdate(),
									}"
									class="flex items-center mt-3 mb-6 px-4 py-1 border border-1 border-gray-400 text-sm leading-4 font-medium rounded-full focus:outline-none"
								>
									<svg class="ml-1 mr-2 flex-shrink-0 h-5 w-5 text-inherit bg-inherit"
										fill="currentColor"
										xmlns="http://www.w3.org/2000/svg"
										[ngStyle]="{'width': screenHeight/60 + 'px'}"
										viewBox="0 0 576 512"
									>
										<path d="M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"/>
									</svg>
									<span [ngStyle]="{'font-size': screenHeight/60 + 'px'}">
										{{ "posts.typeOffer" | translate }}
									</span>
								</button>
							</div>
						</fieldset>
						<app-tooltip-left (onToolTipHeightCalculated)="updateHeight($event, 3)" [visibilityFlag]="toolTipMsgGoogle" [msg]="'posts.step1Validation.chooseTypeForGoogle'" class="flex absolute" [ngClass]="{'-right-[37%]': screenWidth>1650, '-right-[38%]': 1400<screenWidth && screenWidth<1650, '-right-[39%]': 1200<screenWidth && screenWidth<1400,  '-right-[40%]': screenWidth<1200}" [ngStyle]="{'margin-top': - screenHeight*3.5/100 - toolTiHeights[3]/2 - 3+ 'px'}"/>
					</div>
								
					<!-- post content text -->
					<div class="m-5"
						[ngStyle]="{'height': screenHeight *17/100 + 'px'}"
					></div>

					<!-- Hidden input field to store the first link -->
					<input type="hidden" name="link" [value]="firstLink">

					<!-- height: if google is not selected, cover the above (empty) div -->
					<div #divPostTextArea
						id="divPostTextArea"
						class="m-5 transition-all duration-200 ease-linear absolute bottom-0 border border-black bg-white rounded-3xl" 
						[ngStyle]="{
							'height': getPostTextAreaHeight(),
							'overflow': this.divPostTextAreaIsExpanded ? 'visible' : 'hidden',
						}"
						[style.width.px]="screenWidth * 46.76 / 100"
					>
						<textarea #postTextArea
							name=""
							id="text"
							name="text"
							formControlName="text"
							rows="4"
							style="resize: none; height: calc(97% - 1.30rem);"
							required
							class="block w-full p-3 pb-8 pr-[32px] text-sm focus:outline-none focus:ring-cliking_blue focus:border-cliking_blue rounded-t-3xl"
							(input)="detectLinks(postTextArea.value)"
							[ngClass]="{
								'border-cliking_red': toolTipMsg,
								'border-black': !toolTipMsg,
							}"
							placeholder=""
						></textarea>

						<!-- Expand textarea btn -->
						<div class="absolute m-3 top-0 right-0 hover:text-cliking_blue cursor-pointer text-gray-400"
							style="display: flex; align-items: center"
							(click)="toggleExpandDivPostTextArea()"
						>
							<div *ngIf="!this.divPostTextAreaIsExpanded">
								<svg fill="none" viewBox="0 0 24 24" stroke-width="0.7" stroke="currentColor" class="size-6" xmlns="http://www.w3.org/2000/svg">
									<path d="M10.5872 7.3479L16.6613 7.34083L16.6542 13.4149C16.6542 13.6812 16.76 13.9366 16.9483 14.1249C17.1366 14.3132 17.392 14.419 17.6583 14.419C17.9246 14.419 18.18 14.3132 18.3683 14.1249C18.5566 13.9366 18.6624 13.6812 18.6624 13.4149L18.6624 6.34381C18.6629 6.2118 18.6373 6.08099 18.5871 5.95892C18.5368 5.83685 18.4628 5.72595 18.3695 5.6326C18.2761 5.53926 18.1652 5.46531 18.0432 5.41505C17.9211 5.36478 17.7903 5.33918 17.6583 5.33972L10.5872 5.33972C10.4554 5.33972 10.3248 5.36569 10.203 5.41615C10.0811 5.46661 9.97046 5.54057 9.87722 5.63381C9.78398 5.72705 9.71002 5.83774 9.65956 5.95956C9.6091 6.08138 9.58313 6.21195 9.58313 6.34381C9.58313 6.47567 9.6091 6.60624 9.65956 6.72806C9.71002 6.84988 9.78398 6.96057 9.87722 7.05381C9.97046 7.14705 10.0811 7.22101 10.203 7.27147C10.3248 7.32193 10.4554 7.3479 10.5872 7.3479V7.3479ZM13.4156 16.6534L7.3416 16.6605L7.34867 10.5864C7.34921 10.4544 7.32361 10.3236 7.27334 10.2016C7.22307 10.0795 7.14913 9.96859 7.05579 9.87524C6.96244 9.7819 6.85153 9.70796 6.72947 9.65769C6.6074 9.60742 6.47659 9.58182 6.34458 9.58236C6.21257 9.58182 6.08176 9.60742 5.95969 9.65769C5.83762 9.70796 5.72672 9.7819 5.63337 9.87524C5.54003 9.96859 5.46609 10.0795 5.41582 10.2016C5.36555 10.3236 5.33995 10.4544 5.34049 10.5865L5.34049 17.6575C5.33995 17.7895 5.36555 17.9203 5.41582 18.0424C5.46609 18.1645 5.54003 18.2754 5.63337 18.3687C5.72672 18.4621 5.83762 18.536 5.95969 18.5863C6.08176 18.6365 6.21257 18.6622 6.34458 18.6616H13.4156C13.6819 18.6616 13.9373 18.5558 14.1256 18.3675C14.314 18.1792 14.4197 17.9238 14.4197 17.6575C14.4197 17.3912 14.314 17.1358 14.1256 16.9475C13.9373 16.7592 13.6819 16.6534 13.4156 16.6534Z" fill="#9CA3AF"/>
								</svg>
							</div>
							<div *ngIf="this.divPostTextAreaIsExpanded">
								<svg fill="none" viewBox="0 0 24 24" stroke-width="0.7" stroke="currentColor" class="size-6" xmlns="http://www.w3.org/2000/svg">
									<path d="M10.884 14.1217C10.8845 13.9897 10.8589 13.8589 10.8086 13.7368C10.7584 13.6148 10.6844 13.5039 10.5911 13.4105C10.4977 13.3172 10.3868 13.2432 10.2648 13.193C10.1427 13.1427 10.0119 13.1171 9.87988 13.1176L2.80882 13.1176C2.54251 13.1176 2.28712 13.2234 2.09882 13.4117C1.91051 13.6 1.80472 13.8554 1.80472 14.1217C1.80472 14.388 1.91051 14.6434 2.09882 14.8317C2.28712 15.02 2.54251 15.1258 2.80881 15.1258L8.88286 15.1187L8.87579 21.1928C8.87579 21.4591 8.98158 21.7145 9.16988 21.9028C9.35819 22.0911 9.61358 22.1969 9.87988 22.1969C10.1462 22.1969 10.4016 22.0911 10.5899 21.9028C10.7782 21.7145 10.884 21.4591 10.884 21.1928V14.1217ZM13.1184 9.87908C13.1179 10.0111 13.1435 10.1419 13.1938 10.264C13.244 10.386 13.318 10.4969 13.4113 10.5903C13.5047 10.6836 13.6156 10.7576 13.7376 10.8078C13.8597 10.8581 13.9905 10.8837 14.1225 10.8832H21.1936C21.4599 10.8832 21.7153 10.7774 21.9036 10.5891C22.0919 10.4008 22.1977 10.1454 22.1977 9.87909C22.1977 9.61278 22.0919 9.35739 21.9036 9.16909C21.7153 8.98078 21.4599 8.87499 21.1936 8.87499L15.1195 8.88206L15.1266 2.80802C15.1272 2.67601 15.1016 2.54519 15.0513 2.42313C15.001 2.30106 14.9271 2.19016 14.8337 2.09681C14.7404 2.00346 14.6295 1.92952 14.5074 1.87925C14.3853 1.82899 14.2545 1.80339 14.1225 1.80393C13.9905 1.80339 13.8597 1.82899 13.7376 1.87925C13.6156 1.92952 13.5047 2.00346 13.4113 2.09681C13.318 2.19016 13.244 2.30106 13.1938 2.42313C13.1435 2.54519 13.1179 2.67601 13.1184 2.80802L13.1184 9.87908Z" fill="#9CA3AF"/>
								</svg>
							</div>
						</div>
						
						<!-- Emoji / Hashtags div -->
						<div class="absolute bg-white text-sm text-gray-400 border-t border-r border-1 pb-5 rounded-tr-2xl rounded-bl-3xl px-7 h-2 overflow-hidden border-black -mt-[22px] z-10 bottom-0"
							style="display: flex; align-items: center"
						>
							<span class="flex items-center gap-2 pr-5 mt-5 cursor-pointer"
								(click)="toggleEmojiPicker()"
								[ngClass]="{
									'text-cliking_blue':isEmojiPickerOpen,
									'text-gray-400':!isEmojiPickerOpen,
								}"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="14px"
									fill="currentColor"
									viewBox="0 0 512 512"
								>
									<path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
								</svg>
								Emojis
							</span>
							<span class="mt-5">|</span>
							<span (click)="addHashTag()" class="px-5 cursor-pointer m-auto"> # Tags</span>
						</div>

						<!-- Character counter -->
						<div class="absolute bottom-0 right-0 w-[85%] h-5 mb-[1px] mr-3 ml-10 rounded-b-2xl bg-white flex justify-end">
							<!-- linkedin -->
							<div class="text-sm mr-2 flex justify-left items-center gap-1 text-gray-400 w-[65px]" *ngIf=" (linkedinExists && selectedPlatform.includes(SocialMediaPlatform.LINKEDIN))">
								<app-social-media-round-icon [source]="'linkedin'" [greyedOut]="false"></app-social-media-round-icon>
								<span class="text-gray-400"><span [ngClass]="{'text-cliking_red': postTextArea.value.length > 3000, 'text-xs': (3000 - postTextArea.value.length).toString().length > 6}">
									{{3000 - postTextArea.value.length || 0 }}
								</span></span>
							</div>
							<div class="text-sm mr-2 flex justify-left items-center gap-1 text-gray-400 w-[65px]" *ngIf=" (googleExists && selectedPlatform.includes(SocialMediaPlatform.GOOGLE))">
								<app-social-media-round-icon [source]="'google'" [greyedOut]="false"></app-social-media-round-icon>
								<span class="text-gray-400"><span [ngClass]="{'text-cliking_red': postTextArea.value.length > 1500, 'text-xs': (1500 - postTextArea.value.length).toString().length > 6}">
									{{1500 - postTextArea.value.length || 0 }}
								</span></span>
							</div>
							<div class="text-sm mr-2 flex justify-left items-center gap-1 text-gray-400 w-[65px]" *ngIf=" (facebookExists && selectedPlatform.includes(SocialMediaPlatform.FACEBOOK))">
								<app-social-media-round-icon [source]="'facebook'" [greyedOut]="false"></app-social-media-round-icon>
								<span class="text-gray-400"><span [ngClass]="{'text-cliking_red': postTextArea.value.length > 63206, 'text-xs': (63206 - postTextArea.value.length).toString().length > 6 }">
									{{63206 - postTextArea.value.length || 0 }}
								</span></span>
							</div>
							<div class="text-sm mr-2 flex justify-left items-center gap-1 text-gray-400 w-[110px]" *ngIf=" (instagramExists && selectedPlatform.includes(SocialMediaPlatform.INSTAGRAM))">
								<app-social-media-round-icon [source]="'instagram'" [greyedOut]="false"></app-social-media-round-icon>
								<span class="text-gray-400"><span [ngClass]="{'text-cliking_red': postTextArea.value.length > 2200, 'text-xs': (2200 - postTextArea.value.length).toString().length > 6}">
									{{2200 - postTextArea.value.length || 0 }}
								</span></span>
								<span class="text-gray-400 ml-2">
									<span
									  [ngClass]="{
										'text-cliking_red': getHashtagCount() > 30,
										'text-xs': (30 - getHashtagCount()).toString().length > 6
									  }"
									>
									 # {{ 30 - getHashtagCount() || 0 }} 
									</span>
								  </span>
							</div>
						</div>

					</div>
					
				
				</div>

				<!-- Hidden input field to store the first link -->
				<!-- OVERLAY OPT -->
				<div *ngIf="false">
					<input type="hidden" name="link" [value]="firstLink">

					<!-- Main container with overlay and textarea -->
					<div
						#divPostTextArea
						id="divPostTextArea"
						class="m-5 transition-all duration-200 ease-linear absolute bottom-0"
						[ngStyle]="{
							'height': divPostTextAreaIsExpanded
								? 'calc(100% - (1.25rem * 2))'
								: (isGooglePageSelected()
										? (screenHeight * 17 / 100 + 'px')
										: ((screenHeight * 17 / 100 + screenHeight * 0.93 / 10) + 'px')),
							'overflow': divPostTextAreaIsExpanded ? 'visible' : 'hidden'
						}"
						[style.width.px]="screenWidth * 46.76 / 100"
					>
						<!-- Overlay div for highlighting links -->
						<div
							class="absolute top-0 left-0 w-full h-full pointer-events-none"
							[innerHTML]="highlightedText || ''"
							[ngStyle]="{
								'height': divPostTextAreaIsExpanded
									? 'calc(100% - (1.25rem * 2))'
									: (isGooglePageSelected()
											? (screenHeight * 17 / 100 + 'px')
											: ((screenHeight * 17 / 100 + screenHeight * 0.93 / 10) + 'px')),
								'width': screenWidth * 46.76 / 100 + 'px'
							}"
							style="white-space: pre-wrap; word-break: break-word; z-index: 1;"
						></div>

						<!-- Hidden textarea -->
						<textarea
							#postTextArea
							id="text"
							formControlName="text"
							rows="4"
							style="resize: none; display: none;"
							required
							[value]="rawText"
						></textarea>

						<!-- Contenteditable div for input -->
						<div
							contenteditable="true"
							class="block w-full h-full p-3 pb-8 pr-[32px] border text-sm rounded-3xl shadow-sm focus:outline-none focus:ring-cliking_blue focus:border-cliking_blue"
							[ngStyle]="{
								'height': divPostTextAreaIsExpanded
									? 'calc(100% - (1.25rem * 2))'
									: (isGooglePageSelected()
											? (screenHeight * 17 / 100 + 'px')
											: ((screenHeight * 17 / 100 + screenHeight * 0.93 / 10) + 'px')),
								'width': screenWidth * 46.76 / 100 + 'px'
							}"
							(input)="onContentEditableInput($event)"
						>
						</div>

						<!-- Expand textarea button -->
						<div
							class="absolute m-3 top-0 right-0 hover:text-cliking_blue cursor-pointer text-gray-400"
							style="display: flex; align-items: center"
							(click)="toggleExpandDivPostTextArea()"
						>
							<div *ngIf="!divPostTextAreaIsExpanded">
								<!-- Expand Icon -->
								<svg fill="none" viewBox="0 0 24 24" stroke-width="0.7" stroke="currentColor" class="size-6">
									<!-- SVG Path -->
								</svg>
							</div>
							<div *ngIf="divPostTextAreaIsExpanded">
								<!-- Collapse Icon -->
								<svg fill="none" viewBox="0 0 24 24" stroke-width="0.7" stroke="currentColor" class="size-6">
									<!-- SVG Path -->
								</svg>
							</div>
						</div>

						<!-- Emoji / Hashtags div -->
						<div
							class="absolute bg-white text-sm text-gray-400 border-t border-r border-1 pb-5 rounded-tr-2xl rounded-bl-3xl px-7 h-2 overflow-hidden border-black -mt-[22px] ml-1 z-10"
							style="display: flex; align-items: center"
						>
							<span
								class="flex items-center gap-2 pr-5 mt-5 cursor-pointer"
								(click)="toggleEmojiPicker()"
								[ngClass]="{
									'text-cliking_blue': isEmojiPickerOpen,
									'text-gray-400': !isEmojiPickerOpen
								}"
							>
								<svg xmlns="http://www.w3.org/2000/svg" width="14px" fill="currentColor" viewBox="0 0 512 512">
									<path
										d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
									/>
								</svg>
								Emojis
							</span>
							<span class="mt-5">|</span>
							<span (click)="addHashTag()" class="px-5 cursor-pointer m-auto"> # Tags</span>
						</div>
					</div>

					<span class="absolute ml-[85vh] -mt-[25vh] z-20">
						<app-emoji-picker [isVisible]="isEmojiPickerOpen" (emojiPicked)="insertEmoji($event)"></app-emoji-picker>
					</span>
				</div>
				<!-- end OVERLAY OPT -->

				<!-- post media (images and videos )-->
				 <!-- if update: message can't edit -->
				
				<div 
					class="w-1/3 h-fit mt-8 ml-6 mb-5 bg-white p-2 pb-1 rounded-2xl border border-black z-10 relative" 
					[ngClass]="{
						'border-cliking_red': fieldsetColorstagram,
						'border-black': !fieldsetColorstagram,
						'opacity-50': isUpdate(),
					}"
					[style.width.px]="screenWidth * 21.6/100"
				>
					<div *ngIf="isUpdate()" class="absolute top-0 bottom-0 left-0 right-0 cursor-not-allowed"></div>
					<div *ngIf="isUpdate()" class="text-xs px-2">
						{{ "pages.fieldNotEditable" | translate}}
					</div>
					<input
						type="file"
						id="files"
						name="files"
						#fileInput
						multiple
						(change)="previewFiles($event)"
						hidden
						[accept]="generateAccept()"
					/>

					<div class="flex w-full">
						<button
							type="button"
							class="bg-cliking_blue text-white m-1 mb-1 p-3 grow rounded-xl font-light max-h-[50px] flex justify-center items-center"
							[ngClass]="{'cursor-not-allowed': isUpdate()}"
							(click)="isUpdate() ? null : fileInput?.click()"
							>
							<span *ngIf="screenHeight < 1100 && screenWidth < 1400; else fontText " [ngStyle]="{'font-size': screenHeight/120 + screenWidth/120 + 'px'}">
								{{ "posts.addMedias" | translate }}
							</span>
							<ng-template #fontText>
								<span  [ngStyle]="{'font-size': screenHeight/150 + screenWidth/150 + 'px'}">
									{{ "posts.addMedias" | translate }}
								</span>
							</ng-template>
						</button>
					</div>
					<span class="flex font-poppins text-[12px] font-normal leading-[16px] w-full justify-center" style="color:#777171;">
						{{ "posts.acceptedFormats" | translate }}
					</span>
					<div cdkDropList (cdkDropListDropped)="isUpdate() ? null : drop($event)" class=" overflow-auto"
						[style]="{'max-height': screenHeight * 0.5145 + 'px'}"
					>
						<div *ngFor="let slide of previewFilesList; index as i" cdkDrag class="text-xs mb-2">
							<div class="grid grid-cols-12 grid-rows-1 p-2 mx-1 text-gray-700 bg-gray-300 rounded-md cursor-grab">
								<div class="col-span-1 mt-2">
									<svg
										width="15px"
										viewBox="0 0 25 25"
										fill="currentColor"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
										<g id="SVGRepo_tracerCarrier"
											stroke-linecap="round"
											stroke-linejoin="round"
										></g>
										<g id="SVGRepo_iconCarrier">
											<path fill-rule="evenodd"
												clip-rule="evenodd"
												d="M9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14ZM11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5ZM15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"
												fill="#121923"
											></path>
										</g>
									</svg>
								</div>

								<div class="col-span-2 font-medium" (click)="isUpdate() ? null : previewSlide(slide)">
									<img #image
											class="rounded-md cursor-pointer w-8 h-8"
											[src]="fileThumbnail(slide)"
									/>
								</div>
									
								<div class="col-span-7 mt-2 ml-2">
									<span>{{ slide.dimensions }}</span>
								</div>
							
								<div class="col-span-1 text-[8px]">
									<button
										class="border border-1 border-gray-400 bg-white px-2 mt-1 z-10 py-1 ml-2 rounded-[3px] text-gray-400"
										type="button"
										(click)="isUpdate() ? null : removeSlide(slide)"
									>
										<svg xmlns="http://www.w3.org/2000/svg"
											width="16px"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
											<g id="SVGRepo_tracerCarrier"
												stroke-linecap="round"
												stroke-linejoin="round"
											></g>
											<g id="SVGRepo_iconCarrier">
												<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"></path>
											</g>
										</svg>
									</button>
								</div>
							</div>

						</div>
					</div>
					<app-tooltip-up [visibilityFlag]="MediaForInstagram" [msg]="'posts.step1Validation.minimumOneMediaForInstagram'" class="absolute mt-[1.5rem] right-[3%] justify-center pl-1"/>
				</div>
			</div>
		</div>

		<span class="absolute right-12 bottom-10 z-20 w-1/2" >
			<app-emoji-picker [isVisible]="isEmojiPickerOpen" (emojiPicked)="insertEmoji($event)"/>
		</span>
	 	<!-- #endregion -->
			
		<!-- #region step 2 -->
		
		<div class="step2 overflow-auto z-10" *ngIf="creationStep == 1">
			<app-mini-media-browser
			*ngIf="!isUpdate()"
			(onfileConfirmed)="miniMediaBrowserConfirmed($event)"
			(closed)="isMiniMediaBrowserOpen = false"
			[isVisible]="isMiniMediaBrowserOpen"
			[metaData]="selectedFiles"
			[currentMediaBrowserContext]="currentMediaBrowserContext"
			[files]="previewFilesList"
			[isGooglePageSelected]="isGooglePageSelected()"
			[mediaType]="miniMediaBrowserMediaType"
			></app-mini-media-browser>
			<!-- step title  -->
			<h3 class="text-[18px] mt-2 text-center font-bold">
				{{ "posts.intermediateStepTitle" | translate }}
			</h3>
			<!-- media and platform specifications -->
			<div *ngIf="!isUpdate()" class="m-5 flex justify-between flex-wrap">
				<!-- google is selected and  media is not correct -->
				<div
					class="px-2 w-full md:w-6/12"
					*ngIf="
						isGooglePageSelected() && (
						this.previewFilesList.length > 0 &&
						(previewFilesListImagesCount() != 1) ||
						(previewFilesListImagesCount() == 1 && fileTooSmall(this.previewFilesList[0])))
					"
				>
					<app-tooltip-left *ngIf="toolTipMsgGoogleMediaInvalid" [visibilityFlag]="toolTipMsgGoogleMediaInvalid" [msg]="'posts.step2Validation.googleMediaInvalid'"  class="absolute ml-[49%]" 
					[ngClass]="{'bottom-[75%]':(isEventSelected || isOfferSelected), 'bottom-[63%]':isUpdateSelected}"/>

					<fieldset
						class="border border-1 rounded-3xl h-full flex flex-col justify-between"
						[ngClass]="{'border-cliking_red ':fieldsetColorGoogleMediaInvalid ,'border-black':!fieldsetColorGoogleMediaInvalid}"
					>
						<legend class="text-sm px-2 ml-5">
							<span class="inline-flex items-center">
								<!-- google media invalid svg -->
								<svg
									*ngIf="isThereAnyGoogleMediaIssue()"
									fill="red"
									width="16px"
									viewBox="0 0 24 21"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
									<g
										id="SVGRepo_tracerCarrier"
										stroke-linecap="round"
										stroke-linejoin="round"
									></g>
									<g id="SVGRepo_iconCarrier">
										<g id="Warning">
											<g>
												<g>
													<path d="M12.5,8.752a.5.5,0,0,0-1,0h0v6a.5.5,0,0,0,1,0Z"></path>
													<circle cx="11.999" cy="16.736" r="0.5"></circle>
												</g>
												<path d="M18.642,20.934H5.385A2.5,2.5,0,0,1,3.163,17.29L9.792,4.421a2.5,2.5,0,0,1,4.444,0L20.865,17.29a2.5,2.5,0,0,1-2.223,3.644ZM12.014,4.065a1.478,1.478,0,0,0-1.334.814L4.052,17.748a1.5,1.5,0,0,0,1.333,2.186H18.642a1.5,1.5,0,0,0,1.334-2.186L13.348,4.879A1.478,1.478,0,0,0,12.014,4.065Z"></path>
											</g>
										</g>
									</g>
								</svg>

								<!-- google media is valid or skipped -->
								<svg
									*ngIf="!isThereAnyGoogleMediaIssue()"
									width="16px"
									viewBox="0 0 20 20"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
									<g
										id="SVGRepo_tracerCarrier"
										stroke-linecap="round"
										stroke-linejoin="round"
									></g>
									<g id="SVGRepo_iconCarrier">
										<path
											fill="#1DC9B7"
											fill-rule="evenodd"
											d="M3 10a7 7 0 019.307-6.611 1 1 0 00.658-1.889 9 9 0 105.98 7.501 1 1 0 00-1.988.22A7 7 0 113 10zm14.75-5.338a1 1 0 00-1.5-1.324l-6.435 7.28-3.183-2.593a1 1 0 00-1.264 1.55l3.929 3.2a1 1 0 001.38-.113l7.072-8z"
										></path>
									</g>
								</svg>
							</span>
							<span class="w-11/12">
								{{ getGoogleMediaWarningMessage() }}
							</span>
							<!-- google svg -->
							<span
								class="inline-flex justify-end p-1 bg-orange-600 text-white rounded-md"
							>
								<svg
									fill="currentColor"
									width="11px"
									viewBox="0 0 32 32"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
									<g
										id="SVGRepo_tracerCarrier"
										stroke-linecap="round"
										stroke-linejoin="round"
									></g>
									<g id="SVGRepo_iconCarrier">
										<title>google</title>
										<path d="M16.601 14.648v4.105h9.813c-0.162 2.008-0.982 3.798-2.243 5.18l0.006-0.007c-1.825 1.86-4.364 3.012-7.172 3.012-0.142 0-0.283-0.003-0.424-0.009l0.020 0.001c-5.946-0.003-10.765-4.823-10.765-10.77 0-0.051 0-0.102 0.001-0.152l-0 0.008c-0.001-0.043-0.001-0.094-0.001-0.145 0-5.946 4.819-10.767 10.765-10.77h0c0.040-0.001 0.087-0.001 0.135-0.001 2.822 0 5.383 1.121 7.262 2.941l-0.003-0.003 2.888-2.888c-2.568-2.578-6.121-4.174-10.047-4.174-0.082 0-0.164 0.001-0.246 0.002l0.012-0c-0.002 0-0.005 0-0.008 0-8.337 0-15.11 6.699-15.228 15.009l-0 0.011c0.118 8.32 6.891 15.020 15.228 15.020 0.003 0 0.006 0 0.009 0h-0c0.169 0.007 0.367 0.012 0.566 0.012 3.892 0 7.407-1.616 9.91-4.213l0.004-0.004c2.208-2.408 3.561-5.63 3.561-9.169 0-0.15-0.002-0.3-0.007-0.449l0.001 0.022c0.001-0.054 0.001-0.119 0.001-0.183 0-0.844-0.079-1.669-0.231-2.469l0.013 0.082z" ></path>
									</g>
								</svg>
							</span>
						</legend>
						<!-- selected img  preview -->
						<div *ngIf="googleMediaBrowserContext.data?.selected" class="flex justify-center items-center w-full h-full mt-4">
							<img class="w-1/2" [src]="googleMediaBrowserContext.data?.selected?.url || ''"  referrerpolicy="no-referrer" alt="Selected image">
						</div>
						<div *ngIf="googleMediaBrowserContext.data?.isSkipped" class="flex justify-center items-center w-full h-full mt-4">
							<img class="w-1/3" src="assets/img/label-icons/no-media.svg" referrerpolicy="no-referrer" alt="Selected image">
						</div>

						<div class="flex justify-center items-center text-center xl:mt-4 mb-2">
							<span
								class="z-10 cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
								(click)="OpenMiniMediaBrowser($event, googleMediaBrowserContext, 'photos')"
							>
								<span class="grid grid-cols-5">
									<span class="col-span-1 flex justify-center items-center">
										<svg
											fill="currentColor"
											stroke="currentColor"
											width="20px"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 640 512"
										>
											<path d="M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"/>
										</svg>
									</span>
									<span class="col-span-4 flex justify-center items-center">
										{{ "posts.selectFromUploadedMedia" | translate }}
									</span>
								</span>
							</span>
							<div *ngIf="false" > <!-- Btn pour charger un nouveau media. Caché pour l'instant-->
								<input
									type="file"
									id="files"
									name="files"
									#fileInput
									multiple
									(change)="previewFiles($event, 'images', true)"
									hidden
									accept="image/png,image/jpeg"
								/>
								<span
									class="grid grid-cols-5 cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
									(click)="fileInput.click()"
								>
									<span class="col-span-1 flex justify-center items-center">
										<svg
											fill="currentColor"
											stroke="currentColor"
											width="20px"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 512 512"
										>
											<path d="M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
										</svg>
									</span>
									<span class="col-span-4 flex justify-center items-center">
										{{ "posts.uploadNewImage" | translate }}
									</span>
								</span>
							</div>
						</div>
					</fieldset>
				</div>

				<!-- facebook/linkedin is selected and  media has more then one videos -->
				<div
					class="px-2 w-full md:w-6/12"
					*ngIf="
						(isFacebookPageSelected() || isLinkedinPageSelected()) &&
						((previewFilesListImagesCount() > 0 &&
							previewFilesList.length > previewFilesListImagesCount()) ||
							previewFilesListVideosCount() > 1)
					"        
				>
					<app-tooltip-left [visibilityFlag]="facebookLinkedinMessageVideo"  [msg]="'posts.step2Validation.facebookLinkedinInvalid'" class="absolute ml-[49%] bottom-[34%]"/>

					<fieldset class="border border-1 border-black rounded-3xl h-full flex flex-col justify-between">
						<legend class="flex justify-between items-center text-sm px-2 ml-5 w-11/12">
							<span class="">
								<!-- Place your warning SVG and text here to allow the text to wrap and fill the available space -->
								<span class="inline-flex items-center mr-2">
									<!-- facebookLinkedin media invalid svg -->
									<svg
										*ngIf="isThereAnyFacebookLinkedinIssue()"
										fill="red"
										width="16px"
										viewBox="0 0 24 21"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
										<g
											id="SVGRepo_tracerCarrier"
											stroke-linecap="round"
											stroke-linejoin="round"
										></g>
										<g id="SVGRepo_iconCarrier">
											<g id="Warning">
												<g>
													<g>
														<path d="M12.5,8.752a.5.5,0,0,0-1,0h0v6a.5.5,0,0,0,1,0Z"></path>
														<circle cx="11.999" cy="16.736" r="0.5"></circle>
													</g>
													<path d="M18.642,20.934H5.385A2.5,2.5,0,0,1,3.163,17.29L9.792,4.421a2.5,2.5,0,0,1,4.444,0L20.865,17.29a2.5,2.5,0,0,1-2.223,3.644ZM12.014,4.065a1.478,1.478,0,0,0-1.334.814L4.052,17.748a1.5,1.5,0,0,0,1.333,2.186H18.642a1.5,1.5,0,0,0,1.334-2.186L13.348,4.879A1.478,1.478,0,0,0,12.014,4.065Z"></path>
												</g>
											</g>
										</g>
									</svg>

									<!-- facebookLinkedin media valid or skipped -->
									<svg
										*ngIf="!isThereAnyFacebookLinkedinIssue()"
										width="16px"
										viewBox="0 0 20 20"
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
									>
										<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
										<g
											id="SVGRepo_tracerCarrier"
											stroke-linecap="round"
											stroke-linejoin="round"
										></g>
										<g id="SVGRepo_iconCarrier">
											<path
												fill="#1DC9B7"
												fill-rule="evenodd"
												d="M3 10a7 7 0 019.307-6.611 1 1 0 00.658-1.889 9 9 0 105.98 7.501 1 1 0 00-1.988.22A7 7 0 113 10zm14.75-5.338a1 1 0 00-1.5-1.324l-6.435 7.28-3.183-2.593a1 1 0 00-1.264 1.55l3.929 3.2a1 1 0 001.38-.113l7.072-8z"
											></path>
										</g>
									</svg>
								</span>
								<span
									*ngIf="
										previewFilesListVideosCount() > 1 &&
										previewFilesListImagesCount() == 0
									"
								>
									{{ "mediaWarnings.facebookLinkedinOneVideo" | translate }}
								</span>
								<span
									*ngIf="
										previewFilesListVideosCount() > 0 &&
										previewFilesListImagesCount() > 0
									"
								>
									{{"mediaWarnings.facebookLinkedinOneVideoAndImages" | translate}}
								</span>
							</span>
							<span class="flex justify-between items-center">
								<!-- Facebook SVG Icon -->
								<span class="p-1 bg-blue-600 text-white rounded-md">
									<svg
										width="12px"
										height="12px"
										fill="currentColor"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 320 512"
									>
										<path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/>
									</svg>
								</span>
								<!-- Linkedin SVG Icon -->
								<span class="ml-1 p-1 bg-sky-600 text-white rounded-md">
									<svg
										width="12px"
										height="12px"
										fill="currentColor"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 448 512"
									>
										<path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>
									</svg>
								</span>
							</span>
						</legend>

						<!-- Media preview section -->
						<div *ngIf="facebookLinkedinMediaBrowserContext.data?.selected" class="flex justify-center w-full mt-4 relative">
							
							<!-- Main Image or Video -->
							<div *ngIf="isImage(facebookLinkedinMediaBrowserContext.data?.selected)" class="relative flex justify-center items-center min-h-[300px] overflow-hidden p-10">
								<!-- Background image 1 with rotation -->
								<img *ngIf="facebookLinkedinMediaBrowserContext.data?.selection?.[1] && isImage(facebookLinkedinMediaBrowserContext.data?.selection?.[1])"
								class="w-1/2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-3 z-0 border border-dark_blue"
								[src]="facebookLinkedinMediaBrowserContext.data?.selection?.[1]?.url || ''"
								alt="Background image 1">
								
								<!-- Background image 2 with rotation -->
								<img *ngIf="facebookLinkedinMediaBrowserContext.data?.selection?.[2] && isImage(facebookLinkedinMediaBrowserContext.data?.selection?.[2])"
									class="w-1/2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-6 z-0 border border-dark_blue"
									[src]="facebookLinkedinMediaBrowserContext.data?.selection?.[2]?.url || ''"
									alt="Background image 2">

								<!-- Main Image (on top) -->
								<img class="w-1/2 relative z-10 border border-dark_blue" *ngIf="isImage(facebookLinkedinMediaBrowserContext.data?.selected)"
									[src]="facebookLinkedinMediaBrowserContext.data?.selected?.url || ''"
									alt="Selected image">
							</div>
								
							<video class="w-1/2 relative z-10" *ngIf="isVideo(facebookLinkedinMediaBrowserContext.data?.selected)" [src]="facebookLinkedinMediaBrowserContext.data?.selected?.url || ''" controls alt="Selected video"></video>
						</div>
						<span *ngIf="isImage(facebookLinkedinMediaBrowserContext.data?.selected)" class="text-center">{{facebookLinkedinMediaBrowserContext.data?.selection?.length || 0}} {{ (facebookLinkedinMediaBrowserContext.data?.selection?.length || 0) > 1 ? ("posts.videoPhotosValidation.selectedImages" | translate) : "posts.videoPhotosValidation.selectedImage" | translate}} </span>

						<div *ngIf="facebookLinkedinMediaBrowserContext.data?.isSkipped" class="flex justify-center w-full mt-4">
							<img class="w-1/3" src="assets/img/label-icons/no-media.svg" alt="No media selected">
						</div>


						<div class="flex justify-center items-center text-center xl:mt-4 mb-2">
							<span class="">
								<!-- Main selection: Video, Photo(s), No Media -->
								<ng-container *ngIf="mediaSelectionStep === 'initial'">
									<div class="flex justify-center items-center text-center">
										<!-- Video btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="selectMediaType('video')"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20px">
														<path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5" />
													</svg>
													
												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.video" | translate }}
												</span>
											</span>
										</span>
										<!-- Images btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="selectMediaType('images')"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20px">
														<path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
													</svg>
													
												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.images" | translate }}
												</span>
											</span>
										</span>
										<!-- noMedia btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="selectMediaType('none')"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20px">
														<path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
													</svg>
													
												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.noMedia" | translate }}
												</span>
											</span>
										</span>
									</div>
								</ng-container>
					
								<!-- Video selection: Choose video or upload new -->
								<ng-container *ngIf="mediaSelectionStep === 'video'">
									<span class="flex items-center mb-2">
										<!-- chooseVideo btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="OpenMiniMediaBrowser($event, facebookLinkedinMediaBrowserContext, 'videos')"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20px">
														<path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5" />
													</svg>
													
												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.chooseVideo" | translate }}
												</span>
											</span>
										</span>

										<input
											type="file"
											id="files"
											name="files"
											#fileInput
											multiple
											(change)="previewFiles($event, 'video')"
											hidden
											accept="image/png,image/jpeg"
										/>
												
										<!-- uploadNewVideo btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="fileInput.click()"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													
													<svg
														fill="currentColor"
														stroke="currentColor"
														width="20px"
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 512 512"
													>
														<path d="M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
													</svg>
													
												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.uploadNewVideo" | translate }}
												</span>
											</span>
										</span>
									</span>
							
									<!-- Turn back button -->
									<div class="flex justify-center">
										<span
											class="z-10 flex cursor-pointer w-fit text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="backToMainSelection()"
										>
											<span class="flex justify-center items-center">
												{{"posts.videoPhotosValidation.back" | translate }}
											</span>
											
										</span>
									</div>
								</ng-container>
							
								<!-- Photo(s) selection: Choose photo(s) or upload new -->
								<ng-container *ngIf="mediaSelectionStep === 'images'">
									<span class="flex items-center mb-2">
										<!-- <button class="btn" (click)="OpenMiniMediaBrowser($event, facebookLinkedinMediaBrowserContext, 'images')">{{"posts.videoPhotosValidation.chooseImages" | translate }}</button> -->
										<!-- chooseImages btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="OpenMiniMediaBrowser($event, facebookLinkedinMediaBrowserContext, 'images')"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20px">
														<path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
													</svg>

												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.chooseImages" | translate }}
												</span>
											</span>
										</span>
										<input
											type="file"
											id="files"
											name="files"
											#fileInput
											multiple
											(change)="previewFiles($event, 'images')"
											hidden
											accept="image/png,image/jpeg"
										/>
										
										<!-- uploadNewImage btn -->
										<span
											class="cursor-pointer text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="fileInput.click()"
										>
											<span class="grid grid-cols-5">
												<span class="col-span-1 flex justify-center items-center">
													
													<svg
														fill="currentColor"
														stroke="currentColor"
														width="20px"
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 512 512"
													>
														<path d="M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
													</svg>
													
												</span>
												<span class="col-span-4 flex justify-center items-center">
													{{"posts.videoPhotosValidation.uploadNewImage" | translate }}
												</span>
											</span>
										</span>
										
									</span>
					
									<!-- Turn back button -->
									<div class="flex justify-center">
										<span
											class="z-10 flex cursor-pointer w-fit text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="backToMainSelection()"
										>
											<span class="flex justify-center items-center">
												{{"posts.videoPhotosValidation.back" | translate }}
											</span>
											
										</span>
									</div>
								</ng-container>
							
								<!-- No Media selected: Display a message or keep this section empty -->
								<ng-container *ngIf="mediaSelectionStep === 'none'">
									<p class="text-sm text-gray-600">{{"posts.videoPhotosValidation.noMediaSelected" | translate }}</p>
					
									<!-- Turn back button -->
									<div class="flex justify-center">
										<span
											class="z-10 flex cursor-pointer w-fit text-xs m-3 bg-gray-300 px-5 py-5 rounded-2xl border hover:text-cliking_blue hover:border-cliking_blue"
											(click)="backToMainSelection()"
										>
											<span class="flex justify-center items-center">
												{{"posts.videoPhotosValidation.back" | translate }}
											</span>
											
										</span>
									</div>
								</ng-container>
							</span>
							
						</div>
							
					</fieldset>
							
				</div>
			</div>

			<!-- GOOGLE SPECIFIC FIELDS -->
			<div class="text-base">
				<!-- if google event or offer choosen  -->
				<!-- LocalPostEvent -->
				<fieldset
					*ngIf="isEventSelected || isOfferSelected"
					class="border border-1 rounded-3xl mx-5 my-12"
					[ngClass]="{'border-cliking_red ':fieldsetColorGoogleEventOfferDateValid ,'border-black':!fieldsetColorGoogleEventOfferDateValid}"
				>
					<app-tooltip-up 
						[visibilityFlag]="toolTipMsgGoogleEventOfferDateValid" [msg]="'posts.step2Validation.eventOfferEndDateInvalid'" 
						class="absolute right-[22%] "
						[ngClass]="{'bottom-[40%]':previewFilesListImagesCount()> 1 && isOfferSelected,'bottom-[52%]':previewFilesListImagesCount()<2 && isOfferSelected,
						'bottom-[35%]':previewFilesListImagesCount()>1 && isEventSelected,'bottom-[46%]':previewFilesListImagesCount()<2 && isEventSelected}"
					/>

					<legend class="text-sm px-2 ml-5 mt-2">
						{{ "posts.offerOrEventSettings" | translate }}
						<!-- google svg -->
						<span class="inline-flex items-center p-1 bg-orange-600 text-white rounded-md">
							<svg
								fill="currentColor"
								width="11px"
								viewBox="0 0 32 32"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									<title>google</title>
									<path
										d="M16.601 14.648v4.105h9.813c-0.162 2.008-0.982 3.798-2.243 5.18l0.006-0.007c-1.825 1.86-4.364 3.012-7.172 3.012-0.142 0-0.283-0.003-0.424-0.009l0.020 0.001c-5.946-0.003-10.765-4.823-10.765-10.77 0-0.051 0-0.102 0.001-0.152l-0 0.008c-0.001-0.043-0.001-0.094-0.001-0.145 0-5.946 4.819-10.767 10.765-10.77h0c0.040-0.001 0.087-0.001 0.135-0.001 2.822 0 5.383 1.121 7.262 2.941l-0.003-0.003 2.888-2.888c-2.568-2.578-6.121-4.174-10.047-4.174-0.082 0-0.164 0.001-0.246 0.002l0.012-0c-0.002 0-0.005 0-0.008 0-8.337 0-15.11 6.699-15.228 15.009l-0 0.011c0.118 8.32 6.891 15.020 15.228 15.020 0.003 0 0.006 0 0.009 0h-0c0.169 0.007 0.367 0.012 0.566 0.012 3.892 0 7.407-1.616 9.91-4.213l0.004-0.004c2.208-2.408 3.561-5.63 3.561-9.169 0-0.15-0.002-0.3-0.007-0.449l0.001 0.022c0.001-0.054 0.001-0.119 0.001-0.183 0-0.844-0.079-1.669-0.231-2.469l0.013 0.082z"
									></path>
								</g>
							</svg>
						</span>
					</legend>

					<!-- offers duration -->
					<div class="mx-5 my-2 mt-2">
						<div class="grid grid-cols-2">
							<div class="col-span-1">
								<label class="text-base" for="">
									{{ "dates.startDate" | translate }} :
								</label>
								<app-date-picker
									[value]="googleEventOfferStartDate" (valueChanged)="updateGoogleEventOfferDate($event,'start')"
								></app-date-picker>

								<span class="text-base ml-2">
									{{ "generic.at" | translate }}
								</span>
								<app-time-picker
									[value]="googleEventOfferStartDate" (valueChanged)="updateGoogleEventOfferTime($event,'start')"
								></app-time-picker>
							</div>

							<div class="col-span-1">
								<label class="text-base" for="">
									{{ "dates.endDate" | translate }} :
								</label>
								<app-date-picker
									[value]="googleEventOfferEndDate" (valueChanged)="updateGoogleEventOfferDate($event,'end')"
								></app-date-picker>

								<span class="ml-2 text-base">
									{{ "generic.at" | translate }}
								</span>
								<app-time-picker
									[value]="googleEventOfferEndDate" (valueChanged)="updateGoogleEventOfferTime($event,'end')"
								></app-time-picker>
							</div>
						</div>
					</div>
				</fieldset>
			
				<!-- if google offer is chosen -->
				<!-- LocalPostOffer -->
				<fieldset
					*ngIf="isOfferSelected"
					class="border border-1 border-black rounded-3xl mx-5 my-12"
				>
					<legend class="text-sm px-2 ml-5 mt-2">
						{{ "posts.offerSettings" | translate }}
						<!-- google svg -->
						<span class="inline-flex items-center p-1 bg-orange-600 text-white rounded-md">
							<svg
								fill="currentColor"
								width="11px"
								viewBox="0 0 32 32"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									<title>google</title>
									<path
										d="M16.601 14.648v4.105h9.813c-0.162 2.008-0.982 3.798-2.243 5.18l0.006-0.007c-1.825 1.86-4.364 3.012-7.172 3.012-0.142 0-0.283-0.003-0.424-0.009l0.020 0.001c-5.946-0.003-10.765-4.823-10.765-10.77 0-0.051 0-0.102 0.001-0.152l-0 0.008c-0.001-0.043-0.001-0.094-0.001-0.145 0-5.946 4.819-10.767 10.765-10.77h0c0.040-0.001 0.087-0.001 0.135-0.001 2.822 0 5.383 1.121 7.262 2.941l-0.003-0.003 2.888-2.888c-2.568-2.578-6.121-4.174-10.047-4.174-0.082 0-0.164 0.001-0.246 0.002l0.012-0c-0.002 0-0.005 0-0.008 0-8.337 0-15.11 6.699-15.228 15.009l-0 0.011c0.118 8.32 6.891 15.020 15.228 15.020 0.003 0 0.006 0 0.009 0h-0c0.169 0.007 0.367 0.012 0.566 0.012 3.892 0 7.407-1.616 9.91-4.213l0.004-0.004c2.208-2.408 3.561-5.63 3.561-9.169 0-0.15-0.002-0.3-0.007-0.449l0.001 0.022c0.001-0.054 0.001-0.119 0.001-0.183 0-0.844-0.079-1.669-0.231-2.469l0.013 0.082z"
									></path>
								</g>
							</svg>
						</span>
					</legend>

					<div class="mx-5 my-2">
						<div class="grid grid-cols-12 gap-8">
							<div class="col-span-3 relative w-full">
								<span class="w-full">
									<label class="ml-5 text-base" for="">
										{{ "posts.cuponCode" | translate }} :
									</label>
									<input
										type="text"
										formControlName="g_localPostOffer_couponCode"
										class="border border-1 border-black rounded-3xl w-full p-1"
										[ngClass]="{'border-cliking_red ':fieldsetColorcuponCode ,'border-black':!fieldsetColorcuponCode}"
										(blur)="cuponCodeValidation()"
									/>
								</span>
								<app-tooltip-up [visibilityFlag]="toolTipMsgcuponCode" [msg]="'posts.step2Validation.cuponCodeRequieredMsg'" 
									class="absolute left-1/2 -translate-x-1/2 top-0 translate-y-full w-full"
								/>
							</div>
							<div class="col-span-4 relative">
								<span class="w-full">
									<label class="ml-5 text-base" for="">
										{{ "posts.offerLink" | translate }} :
									</label>
									<input
										type="text"
										formControlName="g_localPostOffer_redeemOnlineUrl"
										class="border border-1 border-black rounded-3xl w-full p-1"
										[ngClass]="{'border-cliking_red ':fieldsetColorValidLink ,'border-black':!fieldsetColorValidLink}"
									/>
								</span>
								<span *ngIf="waitingLinkValidation" class="animate-pulse ml-2">{{'posts.step2Validation.checkingLink' | translate}}</span>
								<app-tooltip-up [visibilityFlag]="toolTipMsgValidLink" [msg]="msgValidLink" 
									class="absolute left-1/2 -translate-x-1/2 translate-y-full w-max"
								/>
							</div>
							<div class="col-span-5">
								<span class="w-full">
									<label class="ml-5 text-base" for=""
										>{{ "posts.offerRequirments" | translate }} :
									</label>
									<textarea
										formControlName="g_localPostOffer_termsConditions"
										type="text"
										rows="3"
										style="resize: none"
										class="border border-1 border-black rounded-2xl w-full p-1"
									></textarea>
								</span>
							</div>
						</div>
					</div>
				</fieldset>

				<!-- if google update or event is choosen -->
				<!-- CallToAction -->
				<fieldset
					*ngIf="isUpdateSelected || isEventSelected"
					class="border border-1 border-black rounded-3xl mx-5 my-12"
				>
				<app-tooltip-up [visibilityFlag]="MediaForInstagram" [msg]="'posts.step1Validation.minimumOneMediaForInstagram'" class="absolute mt-[1.5rem] right-[3%] w-[30%] justify-center pl-1"/>				

					<legend class="text-sm px-2 ml-5">
						{{ "posts.updateOrEventSettings" | translate }}
						<!-- google svg -->
						<span
							class="inline-flex items-center p-1 bg-orange-600 text-white rounded-md"
						>
							<svg
								fill="currentColor"
								width="11px"
								viewBox="0 0 32 32"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									<title>google</title>
									<path
										d="M16.601 14.648v4.105h9.813c-0.162 2.008-0.982 3.798-2.243 5.18l0.006-0.007c-1.825 1.86-4.364 3.012-7.172 3.012-0.142 0-0.283-0.003-0.424-0.009l0.020 0.001c-5.946-0.003-10.765-4.823-10.765-10.77 0-0.051 0-0.102 0.001-0.152l-0 0.008c-0.001-0.043-0.001-0.094-0.001-0.145 0-5.946 4.819-10.767 10.765-10.77h0c0.040-0.001 0.087-0.001 0.135-0.001 2.822 0 5.383 1.121 7.262 2.941l-0.003-0.003 2.888-2.888c-2.568-2.578-6.121-4.174-10.047-4.174-0.082 0-0.164 0.001-0.246 0.002l0.012-0c-0.002 0-0.005 0-0.008 0-8.337 0-15.11 6.699-15.228 15.009l-0 0.011c0.118 8.32 6.891 15.020 15.228 15.020 0.003 0 0.006 0 0.009 0h-0c0.169 0.007 0.367 0.012 0.566 0.012 3.892 0 7.407-1.616 9.91-4.213l0.004-0.004c2.208-2.408 3.561-5.63 3.561-9.169 0-0.15-0.002-0.3-0.007-0.449l0.001 0.022c0.001-0.054 0.001-0.119 0.001-0.183 0-0.844-0.079-1.669-0.231-2.469l0.013 0.082z"
									></path>
								</g>
							</svg>
						</span>
					</legend>

					<div class="m-5">
						<div class="grid grid-cols-3 gap-8">
							<div class="col-span-1">
								
								<select
									#selectElement
									name=""
									id=""
									[value]="dynamicAdditionalData || ''"
									(change)="onSelectChange(selectElement.value)"
									class="border border-1 c-border-blue c-text-blue px-2 py-1 rounded-full w-full"
								>
									<option value="">{{ "generic.selectOption" | translate }}</option>
									<option value="BOOK">
										{{ "google.buttons.BOOK" | translate }}
									</option>
									<option value="ORDER">
										{{ "google.buttons.ORDER" | translate }}
									</option>
									<option value="SHOP">
										{{ "google.buttons.SHOP" | translate }}
									</option>
									<option value="LEARN_MORE">
										{{ "google.buttons.LEARN_MORE" | translate }}
									</option>
									<option value="SIGN_UP">
										{{ "google.buttons.SIGN_UP" | translate }}
									</option>
									<option value="CALL">
										{{ "google.buttons.CALL" | translate }}
									</option>
								</select>
							</div>
							<div class="col-span-2 flex items-center relative" *ngIf="dynamicAdditionalData && selectedLabel !== 'generic.phone'">
								<label class="text-base shrink-0" for="g_callToAction_url">
									{{selectedLabel|translate}} :
								</label>
								<input
									id="g_callToAction_url"
									type="text"
									(blur)="dynamicAdditionalDataValidation()"
									formControlName="g_callToAction_url"
									class="ml-3 border border-1 border-black rounded-3xl flex-grow p-1"
									[ngClass]="{'borde-black':!fieldsetColorDataValidation, 'border-cliking_red':fieldsetColorDataValidation}"
								/>
								<span *ngIf="waitingLinkValidation" class="animate-pulse ml-2">{{'posts.step2Validation.checkingLink' | translate}}</span>
								<app-tooltip-up [visibilityFlag]="(AdditionalDataValidation != '' && AdditionalDataValidation=='other')|| toolTipMsgValidLink" [msg]="msgValidLink" 
									class="absolute left-1/2 -translate-x-1/2 top-0 translate-y-full w-max"
								/>
								<app-tooltip-up [visibilityFlag]="AdditionalDataValidation != '' && AdditionalDataValidation=='CALL'" [msg]="'posts.step2Validation.nbPhoneNotValid'" 
									class="absolute left-1/2 -translate-x-1/2 top-0 translate-y-full w-max"
								/>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

  	<!-- #endregion -->

  	<!-- #region step 3 -->  
    <div class="step3 h-full" *ngIf="creationStep == 2">
      <div class="flex gap-6 p-4 h-full">
        <!-- calendar -->
        <div class="col-span-5 row-span-1 relative">

          <app-date-time-picker [isUpdate]="isUpdate()"  [expectedPublishingDatetime]="postUrl?.expectedPublishingDatetime != '' ? postUrl?.expectedPublishingDatetime : null"/>
		  <app-tooltip-up [visibilityFlag]="goolgeEventOfferDateValid" [msg]="'posts.step3Validation.goolgeEventOfferDateValid'" class="absolute left-1/2 -translate-x-1/2"/>
		  <div *ngIf="!isUpdate()" class="col-span-5 row-span-1 m-auto">
            <div class="grid grid-rows-2 grid-cols-1 mt-5">
              <span class="absolut top-0 border border-1 border-black text-xl inline rounded-full font-bold p-2 w-fit m-auto mb-5">
								{{ "generic.or" | translate }}
							</span>
              <div class="col-span-1 z-50" (click)="SetPublishNow()">
                <button
                  type="button"
                  [ngClass]="{
                    'c-bg-blue text-white': publishNow(),
                    'bg-gray-100 text-gray-400 ': !publishNow()
                  }"
                  class="w-full p-2 px-12 rounded-2xl"
                  
                >
                  {{ "posts.publishNow" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
				
        <!-- preview -->
				<app-social-media-tabs
					class="w-full h-full"	
					[data]="preparePostDataForPreview()"
					[selectedPagesSources]="selectedPagesSources"
					[googleMediaBrowserContext]="googleMediaBrowserContext"
					[previewFilesList]="previewFilesList"
					[socialMediaPagesList]="uniquePageList( socialMediaPagesList)"
					[googleBtnValue]="dynamicAdditionalData"
					[googleAdditionalData]="setGoogleAdditionalData(setTypePost())"
					[calendarView]="false"
				></app-social-media-tabs>


				<!-- <app-post-create-preview [data]="preparePostDataForPreview()" [screenHeight]="screenHeight*0.9" [screenWidth]="screenWidth*0.9" [selectedPlateform]="getChoosedSocialMediaPages()[currentPreviewPlatform]?.source.toLowerCase()"/> -->


        <!-- <div class="col-span-3 row-span-2 w-full h-full">
          <fieldset class="border border-black border-1 rounded-3xl relative h-full">
						<div class="tabs-container">
							<div
								*ngFor="let tab of SOCIAL_MEDIA_PLATFORMS"
								class="tab"
								[@expandCollapse]="getTabState(tab.id)"
								(click)="selectTab(tab.id)"
							>
								<img [src]="tab.icon" alt="{{ tab.name }}" class="icon" />
								<span class="tab-name" *ngIf="selectedTabId === tab.id">{{ tab.name }}</span>
							</div>
						</div>
						<app-post-create-preview [data]="preparePostDataForPreview()" [screenHeight]="screenHeight*0.9" [screenWidth]="screenWidth*0.9" [selectedPlateform]="getChoosedSocialMediaPages()[currentPreviewPlatform]?.source.toLowerCase()"/>
            
          </fieldset>
        </div> -->
      </div>
    </div>
    <!-- steps navigation buttons -->
    <div class="absolute z-40 w-full bottom-0 translate-y-1/3 px-5">
      <div class="flex justify-between mt-5 p-3 pb-0">
        <button
          type="button"
          (click)="prevStep()"
          [class.opacity-0]="creationStep == 0"
          [class.cursor-auto]="creationStep == 0"
          class="flex-grow-0 px-4 ml-20 py-1 c-bg-blue text-white font-normal rounded-full hover:c-bg-blue focus:outline-none focus:ring-2 focus:ring-cliking_blue focus:ring-offset-2 mr-7 border-[3px] border-dark_blue text-base sm:text-lg md:text-xl lg:text-2xl"
        >
          ← {{ "posts.previousStep" | translate }}
        </button>

				

				<app-tooltip-left [visibilityFlag]="addTextOrImageMsg" [msg]="'posts.step1Validation.addTextOrImageMsg'" [down]="true" class="absolute right-0 top-0 -translate-y-1/2" />
        <div class="relative flex flex-col items-center">
          <button #button
            type="button"
            (click)="nextStep($event)"
            class="px-4 py-1 c-bg-blue z-10 text-white font-normal rounded-full border-[3px] border-dark_blue focus:outline-none focus:ring-2 focus:ring-cliking_blue focus:ring-offset-2 mr-10 text-base sm:text-lg md:text-xl lg:text-2xl"
            [disabled]="!canPressNext"
            [ngClass]="{'cursor-not-allowed':!canPressNext}"
						[attr.data-step]="creationStep !== 2 ? 'next' : 'submit'"
          	[style.width.px]="screenWidth * 9.75/100? screenWidth * 9.75/100>127: 127"
          >
						<span [ngStyle]="{'font-size': screenHeight/45 + 'px'}">
							{{
								creationStep !== 2
								? ("posts.nextStep" | translate) + " →"
								: ("posts.finish" | translate)
							}}
						</span>
          </button>
        </div>
      </div>
    </div>

  </fieldset>

  <app-media-preview
		*ngIf="previewOn"
		[isVisible]="previewOn"
		[startingIndex]="previewIndex"
		[slides]="previewFilesList"
		(closed)="hidePreview()"
  ></app-media-preview>
  <!-- #endregion -->
</form>
<app-modal 
  [isOpen]="isModalOpen"
  [heading]="headinsMsg"
  [subHeading]="subHeadinsMsg || ''" 
  (closeModal)="close()" 
  [icon]="modalIcon">
</app-modal>

<app-modal 
	*ngIf="isUpdate() && hasInstagram()"
	[isOpen]="updateModaleOpen" 
	[icon]="modalIconEdit" 
	[heading]="'posts.editInstagram'"
	[subHeading]="''"
	[isEdit]="true"
	[socialMediaInfos]="postService.extractSocialMediaInfo(postUrl, true)"
	[displayAs]="'post'"
	(closeModal)="updateModaleOpen=false" 
></app-modal>
<!-- <app-tooltip-left [visibilityFlag]="toolTipMsgTitle" [msg]="'posts.step1Validation.postTitle'" [style.top.px]="elementsPositions[0]?.Y + elementsPositions[0]?.H/2" [style.left.px]="elementsPositions[0]?.R" class="absolute"/> -->
      <!-- <app-tooltip-left [visibilityFlag]="toolTipMsgPlateforms" [msg]="'posts.step1Validation.choosePlateformSource'" [style.top.px]="elementsPositions[1]?.Y + elementsPositions[1]?.H/2" [style.left.px]="elementsPositions[1]?.R" class="absolute"/> -->
      <!-- <app-tooltip-left [visibilityFlag]="toolTipMsgPages" [msg]="'posts.step1Validation.selectminimumOnePage'" [style.top.px]="elementsPositions[2]?.Y + elementsPositions[2]?.H/2" [style.left.px]="elementsPositions[2]?.R" class="absolute"/> -->
      <!-- <app-tooltip-left [visibilityFlag]="toolTipMsgGoogle" [msg]="'posts.step1Validation.chooseTypeForGoogle'" [style.top.px]="elementsPositions[elementsPositions.length-2]?.Y - screenHeight *0.93/7.75 " [style.left.px]="screenWidth * 0.487" class="absolute"/> -->
      <!-- <app-tooltip-left [visibilityFlag]="toolTipMsg" [msg]="'posts.step1Validation.postText'" [ngClass]="{'mt-[27.5rem]':isGooglePageSelected(), 'mt-[21.5rem]':!isGooglePageSelected()}" class="absolute right-11/12 -ml-[2vh]"/> -->